import { Textarea } from "@/components/ui/textarea";

interface OutcomeItem { id: number; text: string; }
interface OutcomeSectionProps { outcomes: OutcomeItem[]; isEditing: boolean; onOutcomeUpdate: (id: number, text: string) => void; }

const OutcomeSection = ({ outcomes, isEditing, onOutcomeUpdate }: OutcomeSectionProps) => (
  <div>
    <h4 className="flex items-center text-accent font-medium mb-2">OUTCOME<div className="flex-grow ml-2 h-px bg-accent/20"></div></h4>
    <ul className="space-y-2 py-2">
      {outcomes.map((o) => (
        <li key={o.id} className="flex items-start gap-2">
          <span className="text-muted-foreground">{o.id}.</span>
          {isEditing ? <Textarea value={o.text} onChange={(e) => onOutcomeUpdate(o.id, e.target.value)} className="flex-1 resize-none text-sm" onClick={(e) => e.stopPropagation()} /> : <span className="text-muted-foreground">{o.text}</span>}
        </li>
      ))}
    </ul>
  </div>
);

export default OutcomeSection;
